import React, { useEffect, useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "./Alert";
import { Navbar } from "./Navbar";
import { getAvailablePsychs } from "redux/actions/setPsychActions";

export const Layout = (props) => {
    const { children, hideNav } = props;
    const dispatch = useDispatch();
    const { user, role } = useSelector((state) => state.auth);
    const { alert } = useSelector((state) => state.app);
    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        if (!user) {
            (async () => {
                try {
                    const { data } = await axios.get("auth/user");
                    dispatch({ type: "AUTH/SET_USER", payload: data });
                } catch (e) {
                    setRedirect(true);
                }
            })();
        }
    }, [dispatch, user]);

    useEffect(() => {
        if (role === "pupil" && user) {
            dispatch(getAvailablePsychs());
        }
    }, [dispatch, role, user]);

    if (redirect) {
        return <Redirect to={"/"} />;
    }

    return (
        <div className="main">
            {!!alert && <Alert text={alert.text} type={alert.type} />}

            {children}

            {!hideNav && <Navbar />}
        </div>
    );
};
